import { render, staticRenderFns } from "./uppy_invoices.vue?vue&type=template&id=e9faf700&scoped=true"
import script from "./uppy_invoices.vue?vue&type=script&lang=js"
export * from "./uppy_invoices.vue?vue&type=script&lang=js"
import style0 from "./uppy_invoices.vue?vue&type=style&index=0&id=e9faf700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9faf700",
  null
  
)

export default component.exports